import { createSlice } from '@reduxjs/toolkit';

const stateSlice = createSlice({
  name: 'orderManagement/state',
  initialState: {
    sideBarExpand: false,
    sideOrderListBarExpand: false,
    mobileSideBarExpand: false,
    selectedCategory: {},
    selectedFields: { id: 1, fullName: 1, paymentType: 1, createdAt: 1 },
    reply: false,
    accept: false,
    reject: false,
    newMessageDialog: false,
  },
  reducers: {
    updateReply: (state, action) => {
      state.reply = action.payload;
    },
    updateAccept: (state, action) => {
      state.accept = action.payload;
    },
    updateReject: (state, action) => {
      state.reject = action.payload;
    },
    toggleSidebar: (state, action) => {
      state.sideBarExpand = action.payload;
    },
    toggleOrderListSidebar: (state, action) => {
      state.sideOrderListBarExpand = action.payload;
    },
    toggleMobileSidebar: (state, action) => {
      state.mobileSideBarExpand = action.payload;
    },
    toggleNewMessageDialog: (state, action) => {
      state.newMessageDialog = action.payload;
    },
    updateSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
});

export const { updateAccept, updateReject, updateReply, toggleOrderListSidebar, toggleSidebar, toggleMobileSidebar, toggleNewMessageDialog, updateSelectedCategory } = stateSlice.actions;

export default stateSlice.reducer;
